var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1156 12.1545C16.1207 11.6241 16.3364 11.1175 16.715 10.7461C17.0937 10.3747 17.6045 10.1689 18.1349 10.174C18.6653 10.1792 19.1719 10.3948 19.5433 10.7735C19.9148 11.1522 20.1205 11.6629 20.1154 12.1933C20.1102 12.7237 19.8946 13.2304 19.5159 13.6018C19.1372 13.9732 18.6265 14.179 18.0961 14.1738C17.5657 14.1687 17.059 13.9531 16.6876 13.5744C16.3162 13.1957 16.1104 12.6849 16.1156 12.1545ZM10.1159 12.0964C10.121 11.566 10.3366 11.0593 10.7153 10.6879C11.094 10.3165 11.6047 10.1107 12.1352 10.1159C12.6656 10.121 13.1722 10.3366 13.5436 10.7153C13.915 11.094 14.1208 11.6047 14.1157 12.1352C14.1105 12.6656 13.8949 13.1722 13.5162 13.5436C13.1375 13.915 12.6268 14.1208 12.0964 14.1157C11.566 14.1105 11.0593 13.8949 10.6879 13.5162C10.3165 13.1375 10.1107 12.6268 10.1159 12.0964ZM4.11614 12.0382C4.12128 11.5078 4.33692 11.0012 4.71561 10.6297C5.0943 10.2583 5.60503 10.0525 6.13543 10.0577C6.66584 10.0628 7.17248 10.2785 7.5439 10.6572C7.91532 11.0358 8.12109 11.5466 8.11595 12.077C8.11081 12.6074 7.89517 13.114 7.51648 13.4855C7.13779 13.8569 6.62706 14.0626 6.09666 14.0575C5.56625 14.0524 5.05961 13.8367 4.68819 13.458C4.31677 13.0793 4.111 12.5686 4.11614 12.0382Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.dfe4f5918e8d71834a683d94bf29844f.svg";
export { ForwardRef as ReactComponent };